export default {
  isViewRollBook: false
};
